import dayjs from 'dayjs'
import round from 'lodash/round'

export const calculateBMI = (height: number, weight: number) =>
  round(weight / ((height * height) / 10000), 2)

export const calculateAge = (birthDate: Date) =>
  dayjs().diff(dayjs(birthDate), 'year')
